export enum SkuSlaBuyerQtyRangeOptionEnum {
  NO_ADDITIONAL = 'NO_ADDITIONAL',
  USE_MARKUP = 'USE_MARKUP',
  PRICING_ENGINE = 'PRICING_ENGINE',
}

export enum SkuSlaPricingModelEnum {
  PRICING_ENGINE = 'PRICING_ENGINE',
  UNIT_PRICE = 'UNIT_PRICE',
}

export interface SkuSlaSupplierRangeDTO {
  low: number;
  high: number;
  pricingEnginePrice: number;
  priceToPaySupplier: number;
}

export interface SkuSlaBuyerRangeDTO {
  low: number;
  high: number;
  option: SkuSlaBuyerQtyRangeOptionEnum;
  priceEachFromSupplierPrice: number;
  priceEach: number;
  markup: number;
  markupValue: number;
  turnaroundHours: number;
}

export interface SkuSlaBuyerConfigDTO {
  sendToRfm: boolean;
  ranges: SkuSlaBuyerRangeDTO[];
  maxQty: number;
}

export interface SkuSlaSupplierConfigDTO {
  maxQty: number;
  pricingModel: SkuSlaPricingModelEnum;
  qtyRangeType: SkuSlaSupplierQtyRangeTypeEnum;
  ranges: SkuSlaSupplierRangeDTO[];
}

export interface SkuSlaDTO {
  id: number;
  skuId: number;
  skuName: string;
  supplierOrgId: number;
  orgId: number;
  supplierConfig: SkuSlaSupplierConfigDTO;
  buyerConfig: SkuSlaBuyerConfigDTO;
}

export enum SkuSlaSupplierQtyRangeTypeEnum {
  STANDARD_ALONE = 'STANDARD_ALONE',
  CONTINUOUS = 'CONTINUOUS',
}

export interface SkuDropdownDTO {
  id: number;
  typeId: number;
  name: string;
  typeName: string;
}

export interface SkuSlaCreateParams {
  skuId: number;
  supplierOrgId: number;
  orgId: number;
}
